import React from 'react'

const CanliYayinSvg = ({ width }) => {
  return (
    <svg
      id='play-stream-svgrepo-com'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 26.156 19.124'
    >
      <path
        id='Path_3185'
        data-name='Path 3185'
        d='M6.38,4.44a.912.912,0,0,1,0,1.29,11.253,11.253,0,0,0,.072,16,.912.912,0,1,1-1.277,1.3,13.078,13.078,0,0,1-.084-18.6A.912.912,0,0,1,6.38,4.44Zm16,.088a.912.912,0,0,1,1.29.013,13.078,13.078,0,0,1-.083,18.393.912.912,0,1,1-1.292-1.289,11.253,11.253,0,0,0,.071-15.827A.912.912,0,0,1,22.377,4.528ZM9.838,8.206A.912.912,0,0,1,9.8,9.5a5.637,5.637,0,0,0,.041,8.395A.912.912,0,1,1,8.6,19.233,7.461,7.461,0,0,1,8.548,8.163.912.912,0,0,1,9.838,8.206Zm9.044.046a.912.912,0,0,1,1.29-.029,7.457,7.457,0,0,1-.052,10.95.912.912,0,1,1-1.25-1.33,5.633,5.633,0,0,0,.04-8.3A.912.912,0,0,1,18.882,8.252Z'
        transform='translate(-1.25 -4.172)'
        fill='#fff'
        fillRule='evenodd'
      />
      <path
        id='Path_3186'
        data-name='Path 3186'
        d='M14.448,10.765c1.09.8,1.635,1.2,1.635,1.884s-.545,1.084-1.635,1.884c-.3.221-.6.429-.873.6-.241.152-.513.309-.8.464-1.087.6-1.631.892-2.118.563s-.532-1.019-.62-2.4c-.025-.39-.041-.772-.041-1.115s.016-.725.041-1.115c.089-1.379.133-2.069.62-2.4S11.693,9.1,12.78,9.7c.282.154.555.312.8.464C13.849,10.337,14.147,10.545,14.448,10.765Z'
        transform='translate(0.645 -3.126)'
        fill='#fff'
      />
    </svg>
  )
}

export default CanliYayinSvg
